import React, {useEffect, useState, useContext } from "react";
import fixelLogo from "../../img/Fixel_Logo2019vector1.svg";
import { StyledMainContainer, StyledHeader, StyledIFrame, StyledButton, StyledForm } from "./intro.style";
import {cleanName, createSegment} from "../../services/globalService";
import {sendEvent} from "../../services/analytics";
import StateContext from "../../context/StateContext";
import SmallLoader from "../utils/SmallLoader";

const Introduction = () => {
  const {user, dispatch, ACTIONS} = useContext(StateContext)
  const [showSpinner, setShowSpinner] = useState(false);

  const installFixel = async (e) => {
    setShowSpinner(true);
    e.preventDefault();
    try {
          const displayName = cleanName(window.location.href);
          let res = await createSegment({mail: user.email, name: displayName});
          if(typeof res === 'string')
            res = JSON.parse(res.data);
          console.log("%cinstall success", "color:#7ed07e");
          //start reload cycle to set segments map\audiences map and push url to dashboard
          dispatch({ type: ACTIONS.RELOAD_DATA });
          sendEvent({ category: "segment", action: displayName, label: res.code });
    } catch (error) {
      console.error('Function: installFixel, Line 61 (): ', error);
    } finally {
      setShowSpinner(false);
    }
  };

  // cleanup spinner after component unmount
  useEffect(() => {
    return () => setShowSpinner(false);
  }, []);

  return (
    <StyledMainContainer>
      <StyledHeader>
        <img src={fixelLogo} alt="fixel logo" />
        <h1>Hello {user ? user.displayName : ''}</h1>
        <h3>Welcome to Fixel</h3>
        <p>Learn how to get powerful AI-Segmented Audiences Across Ad Platforms</p>
      </StyledHeader>

      <StyledIFrame title="Fixel introduction video" width="470" height="269" src="https://www.youtube.com/embed/UkioxVbrDNA?modestbranding=1&rel=0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></StyledIFrame>

      {user && <StyledForm onSubmit={installFixel}>
        <StyledButton type="submit" disabled={showSpinner}>
          {" "}
          {showSpinner ? <SmallLoader inline={true} /> : "Install Fixel"}
        </StyledButton>
      </StyledForm>}
    </StyledMainContainer>
  );
};
export default Introduction;
